const pagination = {
  page: -1,
  size: -1,
  pageCount: -1,
  rows: []
};
export const initialState = {
  session: {
    JwtToken: null,
    user: { ...pagination }
  },
  banner: {
    list: { ...pagination },
    current: {}
  },
  image: {
    list: { ...pagination },
    current: {}
  },
  file: {
    list: { ...pagination },
    current: {}
  },
  number: {
    list: { ...pagination },
    current: {}
  },
  new: {
    list: { ...pagination },
    current: {}
  },
  nation: {
    list: { ...pagination },
    current: {}
  },
  column: {
    list: { ...pagination },
    current: {}
  },
  activity: {
    list: { ...pagination },
    current: {}
  },
  video: {
    list: { ...pagination },
    current: {}
  },
  tag: {
    list: { ...pagination },
    current: {}
  },
  magazine: {
    list: { ...pagination },
    current: {}
  },
  faq: {
    list: { ...pagination },
    current: {},
    categories: [],
    subcategories: { ...pagination }
  },
  meeting: {
    list: { ...pagination },
    current: {},
    categories: [],
    subcategories: { ...pagination }
  },
  eurofile: {
    list: { ...pagination },
    current: {},
  },
};
